import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { TodosContext } from '../contexts/TodoContext';
import { TostContext } from '../contexts/TostContext';
import { useContext } from 'react';


export default function ItemTodo({idParam,title,content,completed,onDelete,onEdit }){

    
    const {showHideToastAlert} =useContext(TostContext);;
    const {todoList,dispatch}=useContext(TodosContext)
    // the todo is completed
    const finishingItem = ()=>{
        dispatch({type:"completed",payload:{id:idParam}})
        showHideToastAlert("تم التعديل بنجاح")
    };

     // the step of deleting todo 
    const deletedItem = ()=>{
        onDelete()
    };
    const editingItem = ()=>{
        onEdit()
    };
    return(
        <>
        <Box className='todo-container'  sx={{ flexGrow: 1,padding:'10px',backgroundColor:'#FFD54F',margin:'20px 0' }} >
            <Grid container spacing={1}>
                <Grid size={8}>
                    <h2 style={{fontSize:'28px',margin:'10px 0',textDecoration:completed?"line-through":"none"}}>{title} </h2>
                    <p style={{fontSize:'20px',margin:'0'}}>{content}</p>
                </Grid>
                <Grid size={4} style={{display:'flex',justifyContent:'space-evenly',alignItems:'center'}}>
                    <IconButton className='icon-btn' onClick={finishingItem} aria-label="finish" style={{fontSize:'35px',backgroundColor: completed ?'#00C853':'#fff',color:completed?'#fff':'#00C853',border:'3px solid #00C853'}}>
                        <CheckCircleOutlineIcon />
                    </IconButton>
                    <IconButton className='icon-btn' onClick={editingItem}  aria-label="edit" style={{fontSize:'35px',backgroundColor:'#fff',color:'#3700B3',border:'3px solid #3700B3'}}>
                        <EditIcon />
                    </IconButton>
                    <IconButton className='icon-btn' onClick={deletedItem} aria-label="delete" style={{fontSize:'35px',backgroundColor:'#fff',color:'#B00020',border:'3px solid #B00020'}}>
                        <DeleteIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Box>
        </>
    )
}



    